import Dashboard from './Dashboard'

export default [{ path: '/dashboard', name: 'dashboard', component: Dashboard }]



// WEBPACK FOOTER //
// ./src/components/dashboard/routes.js